import { defaultStore, stores } from '../../translations'

/**
 * Подключаем ассеты rimmel в игре doodle только на RU store
 * */
export const isJumperRimmelAssets = (store = defaultStore) => {
  const startDate = new Date('2026-11-02T12:00:00')
  const endDate = new Date('2026-12-01T02:00:00+03:00')
  const now = new Date()
  const iAdidasGameActive = now >= startDate && now <= endDate

  return iAdidasGameActive && store === stores.ru
}
